import firebase from "@/firebase";
import util from "@/util";
export default {
  namespaced: true,
  state: {
    tested: 100,
    goal: 100,
    oz: 0,
    vol: 0,
  },
  getters: {
    getTA(state) {
      return state;
    },
  },
  mutations: {
    calcTA(state, settings) {
      const gallons = util.getGallons(settings.volume, settings.unitType);
      const temp = (state.goal - state.tested) * gallons;
      state.vol = util.getVolume((temp / 4259.15) * 0.7988, settings.unitType);
      state.oz = util.getWeight(temp / 4259.15, settings.unitType);
      if (state.tested >= state.goal) state.oz = state.vol = 0;
    },
    setTA(state, ta) {
      if (!ta) {
        return;
      }
      state.tested = Number(ta.tested) || Number(state.tested);
      state.goal = Number(ta.goal) || Number(state.goal);
      state.oz = ta.oz || state.oz;
      state.vol = ta.vol || state.vol;
    },
  },
  actions: {
    async initTA(state) {
      if (!firebase.auth.currentUser) return;
      const doc = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("ta")
        .get();
      const ta = doc.data();
      state.commit("setTA", ta);
    },
    async saveTA(state, data) {
      if (!firebase.auth.currentUser) return;
      await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("calculator")
        .doc("ta")
        .set({
          tested: data.tested,
          goal: data.goal,
          oz: data.oz,
          vol: data.vol,
        });
      state.commit("setTA", data);
    },
  },
};
